import React from "react";
import SignInForm from "../Components/SignInForm";

export default function PartnerSignin() {
  return <SignInForm variant="partner" />;
}
